import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './WidthContainer.scss'


const WidthContainer = ({ children, wide = false, containerClassName, wrapperClassName }) => (
  <div className={cx(s.widthContainer, wrapperClassName)}>
    <div className={cx(s.container, containerClassName, { [s.wide]: wide })}>
      {children}
    </div>
  </div>
)

WidthContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}


export default WidthContainer
